import styled, { keyframes } from 'styled-components';

export const TabWrapper = styled.div`
  position: absolute;
  width: 100%;
`;

export const TopPanelWrapper = styled.div`
  margin-bottom: 5px;
  background-color: #fff;
  position: relative;
  width: 100%;
`;

export const SummaryWrapper = styled.div`
  float: right;
  padding: 10px;
  display: flex;
  margin: 45px 10px 20px 20px;
`;

export const StyledNewFilterWrapper = styled.div`
  display: flex;
  float: left;
  margin: 45px 10px 20px 20px;
`;

export const WrapHeaderTitle = styled.span`
  h2 {
    font-size: 14px;
    white-space: normal;
    font-weight: 500;
    margin: 0;
    line-height: 0.9;
    position: relative;
    display: inline-block;
    color: #fff;
    height: 100%;
    background-color: #F6F6F6;
    border: 1px solid #F6F6F6;

    .noc-title-holder {
      cursor: pointer;
      margin: 0;
      display: block;
      position: relative;
      white-space: normal;
      height: 100%;

      .noc-title {
        display: block;
        margin: 0 auto;
        line-height: 35px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 5px;
        padding-bottom: 0.5rem;
        padding: 0 0 0 15px;
        max-width: 200px;
        overflow-x: hidden;
        color: #333;
        height: 100%;
        font-weight: 700;
        width: 100%;
      }
      &:focus {
        outline: none;
      }
      .vertical-bar {
        position: absolute;
        width: 10px;
        top: 0;
        left: 0;
        bottom: 0;
        background: ${props => props.borderColor};
        z-index: 1;
      }
    }
    &:hover{
      border: 1px solid ${props => props.borderColor};
    }
  }
`;

export const Delimiter = styled.span`
  color: #215bff;
  padding: 0 0.25rem;
`;

export const StyledFilterWrapper = styled.div`
  position: absolute;
  top: 85px;
  left: ${props => props.position.left - 10 || 0}px;
  border: 1px solid #e8e8e8;
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  max-width: 800px;
  & .ant-tabs-tab {
    margin: 0px 5px 5px 0px !important;
  }

  & .ant-checkbox-inner::after {
    border-color: #1890ff !important;
  }

  & .ant-select-selection {
    max-height: 85px;
    overflow: auto;
  }

  & .ant-tabs-extra-content a {
    color: #1890ff !important;
  }
`;

export const ModalMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.6;
  z-index: 70;
  background-color: #d9d9d9;
  & + * {
    z-index: 71;
  }
`;

export const StyledCloseFilter = styled.div`
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  display: flex;
  align-item: center;
  justify-content: center;
  cursor: pointer;
  background-color: #ececec;
  width: 20px;
  align-items: center;
  font-weight: 700;
`;

export const StyledScopeWrapper = styled.div`
  display: flex;
  float: left;
  margin: 45px 10px 20px 20px;
  background-color: #ECECEC;
  &:hover ${StyledCloseFilter} {
    visibility: visible;
    opacity: 1;
  }
`;

export const LiveModeMarker = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  margin-right: 5px;
`;

export const StyledDatePickerWrapper = styled.div`
  background-color: #ECECEC;

  div[class^='display']{
    background-color: #ECECEC;
    border: none;
  }

  div[class^='live']{
    background-color: #ECECEC;
    display: flex;
    align-items: center;
    border: none;
    i{
      margin-left: 3px;
      margin-top: 3px;
      svg{
        width: 0.4em;
        height: 0.4em;
      }
    }
  }

  #date-picker-live{
    display: flex;
    align-items: baseline;
    i{
      margin-left: 3px;
      svg{
        width: 0.4em;
        height: 0.4em;
      }
    }
  }

  div[class^='intervals']{
    padding-top: 2px;
  }
`;

const blink = keyframes`
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`;

export const TimeTablet = styled.div`
  padding: 6px 10px;
  min-width: 200px;
  text-align: left;
  color: #666;
  border-radius: 5px;
  font-size: 16px;
  float: right;
  background-color: #ECECEC;

  .live-text{
    color: #cc0000;
  }

  & .loading-time span {
    animation-name: ${blink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;
export const MarginLayout = styled.div`
  margin-right: 12.5px !important;
  margin-left: 7.5px !important;
`;
